import { useMemo } from 'react'

import type { WatchList } from '@/state/storage'

type WatchListItem = WatchList['list'][number]

export type ChartEntry = { item: WatchListItem; originalIndex: number }

/**
 * Resolves the chart's "active" watchlist entry. Every watchlist item type — including
 * options — is tracked directly by its own original index; the chart renders whatever
 * instrument is currently selected, with no redirection to an underlying instrument.
 */
export function useResolvedChartEntry({ watchList }: { watchList: WatchList }): {
  chartEntries: ChartEntry[]
  chartSelectedEntry: ChartEntry | null
} {
  const chartEntries = useMemo(
    () => watchList.list.map((item, originalIndex) => ({ item, originalIndex })),
    [watchList.list]
  )

  const chartSelectedEntry = useMemo(
    () => chartEntries[watchList.selectedIndex] ?? null,
    [chartEntries, watchList.selectedIndex]
  )

  return { chartEntries, chartSelectedEntry }
}
